import { render, staticRenderFns } from "./messageTable.vue?vue&type=template&id=406bbffb&"
import script from "./messageTable.vue?vue&type=script&lang=js&"
export * from "./messageTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports